import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=322c31a0&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=js&"
export * from "./product-detail.vue?vue&type=script&lang=js&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=322c31a0&lang=scss&scoped=true&"
import style1 from "./product-detail.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./product-detail.vue?vue&type=style&index=2&id=322c31a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c31a0",
  null
  
)

export default component.exports